var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { hearingLevelsExplained } from '@/constants/hearing-ability-explained.constant';
import { Typography } from '@mui/material';
export function HearingAbilityContent() {
    return (_jsxs("div", __assign({ className: "flex flex-col gap-5" }, { children: [_jsx(Typography, __assign({ variant: 'h3', className: "text-xl font-bold" }, { children: "Hearing ability explained:" })), hearingLevelsExplained.map(function (_a) {
                var title = _a.title, description = _a.description, color = _a.color, icon = _a.icon;
                return (_jsxs("div", __assign({ className: "flex flex-col sm:flex-row gap-4 md:gap-12 items-center" }, { children: [_jsx("img", { src: icon, alt: 'Information icon', className: 'w-10 h-10' }), _jsxs("div", __assign({ className: "flex flex-col md:max-w-80 max-w-72" }, { children: [_jsx(Typography, __assign({ variant: 'h3', className: "text-lg w-full text-center sm:text-left font-semibold ".concat(color) }, { children: title })), _jsx(Typography, __assign({ variant: 'body1', className: "text-center sm:text-left text-lg md:text-xl" }, { children: description }))] }))] })));
            })] })));
}
